import React, {useEffect, useState} from 'react';
import axios from '../Common/axios';
import {getDashBoardReportList, getDashBoardProgress} from '../Common/api';
import {getGridTableHeight} from '../Common/util';
import {useConfigValue} from '../ConfigValue/configData';
import ProgressBoard from './ProgressBoard';
import GroupScoreChart from './GroupScoreChart';
import TopMenu from '../Common/TopMenu';
import Cookies from 'js-cookie';

function DashBoard() {
    const {fetchAndUpdateConfig} = useConfigValue();
    const companyCode = Cookies.get('auth_companyCode');
    // 관리자(ISECURE) 여부
    const isAdmin = companyCode === 'ISECURE';

    const [progressList, setProgressList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(isAdmin ? '' : companyCode);
    const [reportList, setReportList] = useState([]);
    const [defaultString, setDefaultString] = useState("L o a d i n g . . .");

    // 최초 1회: 진행현황 조회 후 기본 선택 회사 결정
    useEffect(() => {
        const initializeDashboard = async () => {
            try {
                await findProgress();
                const configFlag = await fetchAndUpdateConfig(companyCode);
                if (!configFlag) {
                    console.log("환경설정값 누락됨.");
                }
            } catch (error) {
                console.error("Dashboard initialization error:", error);
            }
        };
        initializeDashboard();
    }, []);

    // 선택 회사가 바뀌면 해당 회사 기준으로 하단(레포트/표/차트) 재조회
    // 그래프는 일반 사용자에게만 노출하므로 관리자는 조회하지 않는다.
    useEffect(() => {
        if (!isAdmin && selectedCompany) {
            findDashBoard(selectedCompany);
        }
    }, [selectedCompany]);

    // 회사별/자산그룹별 진행현황 조회
    const findProgress = async () => {
        try {
            const response = await axios.get(getDashBoardProgress());
            const companies = Array.isArray(response.data?.companies) ? response.data.companies : [];
            setProgressList(companies);

            // 관리자는 첫 회사 자동 선택, 일반 사용자는 본인 회사
            if (isAdmin) {
                if (companies.length > 0) {
                    setSelectedCompany(companies[0].com_cd);
                } else {
                    setDefaultString("최근 4개월 내 진행된 회사가 없습니다.");
                }
            } else {
                setSelectedCompany(companyCode);
            }
        } catch (error) {
            console.error("Dashboard progress fetch error:", error);
            setProgressList([]);
            if (!isAdmin) {
                setSelectedCompany(companyCode);
            }
        }
    };

    // 선택 회사의 자산유형별 최종 레포트ID 조회 => 진단항목별 보안수준 현황
    const findDashBoard = async (company) => {
        setDefaultString("L o a d i n g . . .");
        await axios.get(getDashBoardReportList(company, ''))
        .then((response) => {
            if (Array.isArray(response.data)) {
                setReportList(response.data);
                if (response.data.length < 1) {
                    setDefaultString("취약점 분석 정보가 없습니다.");
                }
            } else {
                console.error("Invalid response data format:", response.data);
                setReportList([]);
                setDefaultString("데이터 형식 오류가 발생했습니다.");
            }
        })
        .catch((error) => {
            console.error("DashBoard find error:", error);
            setReportList([]);
            setDefaultString("데이터를 불러오는 중 오류가 발생했습니다.");
        });
    };

    return (
        <>
            <TopMenu selectKey='dashboard' />
            <div>
                <div id="dashboard" style={{height:getGridTableHeight(120), overflowY:'auto', overflowX:'none'}}>
                    {/* 화면이 넓어도 보기 쉽도록 max 1000px 가운데 정렬 */}
                    <div style={{maxWidth:'1000px', margin:'0 auto', width:'100%'}}>
                        {/* 회사별 · 자산그룹별 진행현황 (아코디언). 그래프는 일반 사용자에게만 노출(관리자 제외) */}
                        <ProgressBoard
                            companies={progressList}
                            isAdmin={isAdmin}
                            selectedCompany={selectedCompany}
                            onSelectCompany={setSelectedCompany}
                            chartSlot={
                                isAdmin ? null : (
                                    reportList.length > 0 ? (
                                        <GroupScoreChart reportList={reportList} companyCode={selectedCompany} />
                                    ) : (
                                        <div className="section">
                                            <table style={{width:'100%', height:'60px'}}>
                                                <tbody>
                                                <tr>
                                                    <th><h3>{defaultString}</h3></th>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                )
                            }
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default DashBoard;
